import React, { useEffect, useCallback } from 'react'
// import { navigate } from 'gatsby'
import usePromise from 'shared/hooks/usePromise'
import LoadingText from 'shared/ui/LoadingText'
import api from '../../utils/api'

function ProcessStripeCheckout({ workshop, send, context: { ticketsToPurchase, attendees } }) {
  const createCheckoutSession = useCallback(
    () => api.createWorkshopCheckoutSession(workshop.id, ticketsToPurchase, attendees),
    [workshop.id, ticketsToPurchase, attendees]
  )
  const { response, error, loading } = usePromise(createCheckoutSession)

  useEffect(() => {
    if (!loading) {
      if (error) {
        send({ type: 'ERROR', payload: error.message })
      } else if (response.allFree) {
        // Normally the `success` query variable is a confirmation code, but in the case
        // of an all free checkout, it's empty.
        window.location.href = `/public-workshops/${workshop.id}?success&t=${attendees.length}`
      } else if (response.sessionId) {
        // eslint-disable-next-line no-undef
        const stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY)
        stripe
          .redirectToCheckout({
            sessionId: response.sessionId,
          })
          .then(function (result) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
          })
      }
    }
  }, [response, error, loading])

  return <LoadingText>Please wait while we start the checkout process</LoadingText>
}

export default ProcessStripeCheckout
